import { useCallback } from 'react';
import { HookError } from '../../errorHandlers';

interface AttributesResponse {
  data: Attribute[];
}
interface Attribute {
  name: string;
  customer_id?: number | undefined;
  value: string;
}

export const updateAttributeFetcher = async (
  body: Attribute[]
): Promise<AttributesResponse> => {
  if (!body) {
    throw new HookError('body must be provided to update the customer');
  }
  const updateAttributeResponse = await fetch(
    '/api/customer/update-attribute',
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  );

  if (updateAttributeResponse.status !== 200) {
    throw new HookError('Response status is not 200');
  }

  const { data } = await updateAttributeResponse.json();
  return data;
};

const useUpdateAttribute = () =>
  useCallback(async (body: Attribute[]) => {
    const data = await updateAttributeFetcher(body);
    return data;
  }, []);

export default useUpdateAttribute;
